// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-content {
  position: relative;
  padding: 40px 30px;
  font-size: 14px;
  font-family: var(--app-family1-regular);
}
.modal-content .close-modal {
  position: absolute;
  right: 1em;
  top: 1em;
  width: 20px;
  cursor: pointer;
}
.modal-content h4 {
  color: var(--app-blue);
  font-family: var(--app-family2-bold);
  margin: 0 0 22px 0;
  font-size: 18px;
  text-transform: uppercase;
}
.modal-content p:first-of-type {
  margin: 0;
}
.modal-content .actions {
  --ion-grid-padding: 0;
  margin-top: 32px;
}
.modal-content .actions ion-col {
  --ion-grid-column-padding: 1px;
}
.modal-content .actions ion-button {
  --border-width: 1px;
  --border-style: solid;
  --border-color: var(--app-greylight);
  --background: white;
  --color: var(--app-greydark);
  --border-radius: 0;
  --box-shadow: none;
  height: 38px;
  margin-left: 0;
  margin-right: 0;
  text-transform: none;
  font-size: 16px;
  font-weight: 400;
}
.modal-content .actions ion-button[fill=outline] {
  --background-activated: transparent;
  --background-focused: var(--background-activated);
  --background-hover: var(--background-activated);
  --border-color: var(--app-greylight);
  --color: var(--app-greydark);
  --color-activated: var(--color);
  --color-focused: var(--color);
}
.modal-content .actions .btn-yes {
  --background: var(--ion-color-primary);
  --color: white;
}

#doNotClose {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
#doNotClose img {
  height: fit-content;
}
#doNotClose span {
  padding: 5px;
  text-align: center;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
